import {Component, EventEmitter, HostListener, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {truncateDecimals} from '../../../Custom-Directives-Pipes/truncate-decimals.pipe';
import {MatTableDataSource} from "@angular/material/table";
import {PageEvent} from "@angular/material/paginator";
import {LabSampleModel} from "../../../models/lab-manager/lab-sample";
import {data} from "autoprefixer";


@Component({
    selector: 'app-samples-table',
    templateUrl: './samples-table.component.html',
    styleUrls: ['./samples-table.component.css'],
    standalone: false
})
export class SamplesTableComponent implements OnInit, OnChanges{
  currentPage: number = 0;
  @Input() callResponse: any;
  dataSource: MatTableDataSource<any> = new MatTableDataSource<any>();
  displayedColumns: string[] = [
    'checkbox',
    'farm',
    'field',
    'hectare',
    'sample',
    'sampleType',
    'dateCreated',
    'createdBy',
    'linkedGroup'
  ];
  @Input() isDialog: boolean;
  @Input() submissionStatus: number;
  @Input() pinTypeId: number = 0;
  pageSize: number = 9999;
  tableHeight: string = (window.innerHeight - 500) + 'px';
  totalElements: number = 0;
  @Input() selectedSamples: LabSampleModel[] = [];
  @Input() mergeGroups: any[] = [];
  @Output() emitSelectedSamples: EventEmitter<any> = new EventEmitter<any>();
  @Output() removeSample: EventEmitter<number> = new EventEmitter<number>();
  @Output() paginateChange: EventEmitter<any> = new EventEmitter<any>();
  @Output() mergeSamples: EventEmitter<any> = new EventEmitter<any>();
  @Output() unmergeSamples: EventEmitter<number> = new EventEmitter<number>();

  @HostListener('window:resize', ['$event'])
  onResize() {
    this.tableHeight = (window.innerHeight - 500) + 'px';
  }

  constructor() {
  }

  /**
   * Field size, with the crop definition's cultivar size in brackets when the
   * sample has one: '8.22 (2.55)'.
   *
   * Uses ?? rather than a truthiness check so a recorded size of 0 is shown
   * rather than falling through to the next branch as if it were absent.
   *
   * cultivarSize is resolved server-side from the field's ACTIVE season, not
   * from the sample's own crop definition link. It is therefore null once that
   * season has ended, and on a multi-cultivar field it is the oldest definition
   * rather than the one this sample belongs to.
   */
  hectareDisplay(element: any): string {
    const fieldSize = element?.pinFieldSize ?? element?.pinSamplesPinFieldSize;
    if (fieldSize == null) return '-';

    const field = truncateDecimals(fieldSize, 2);
    const cultivar = element?.cultivarSize;
    return cultivar != null ? field + ' (' + truncateDecimals(cultivar, 2) + ')' : field;
  }

  ngOnInit(): void {
  }



  onPaginateChange(event: PageEvent) {
    // if(this.pageSize != event.pageSize) {
    //   this.selectedSamples = [];
    // }
    this.currentPage = event.pageIndex;
    this.pageSize = event.pageSize;
    this.paginateChange.emit({
      currentPage: this.currentPage,
      pageSize: this.pageSize
    })
  }

  emitChanges() {
    this.emitSelectedSamples.emit(this.selectedSamples);
  }

  removeSampleEmit(sample: any) {
    this.removeSample.emit(sample)
  }

  getMergeCount(sampleId: number): number {
    const group = this.mergeGroups?.find(g => g.primarySampleId === sampleId);
    return group ? group.linkedCount + 1 : 0;
  }

  isMerged(sampleId: number): boolean {
    return this.mergeGroups?.some(g => g.primarySampleId === sampleId || g.linkedSampleIds?.includes(sampleId)) ?? false;
  }

  emitMerge() {
    this.mergeSamples.emit(this.selectedSamples);
    this.selectedSamples = [];
  }

  emitUnmerge(primarySampleId: number) {
    this.unmergeSamples.emit(primarySampleId);
  }

  selectAllSamples(event: any): void {
    this.dataSource.data.forEach(item => {
      this.selectSample(event, item);
    });
  }

  hasSample(sample: LabSampleModel) {
    return this.selectedSamples.findIndex(s => s.id === sample.id) !== -1;
  }

  // hasAllSamples() {
  //   if(this.selectedSamples.length === 0) {
  //     return {all: false, intermediate: false};
  //   } else {
  //     let count = 0;
  //     for(let data of this.dataSource.data) {
  //       if(this.selectedSamples.findIndex(s => s.id === data.id) !== -1) {
  //         count++;
  //       }
  //     }
  //
  //     if(count === 0) {
  //       return {all: false, intermediate: false};
  //     } else if(count === this.dataSource.data.length) {
  //       return {all: true, intermediate: false};
  //     } else {
  //       return {all: false, intermediate: true};
  //     }
  //   }
  // }

  isAllSelected(): boolean {
    return this.dataSource.data.length > 0 &&
        this.dataSource.data.every(r => this.selectedSamples.findIndex(s => s.id === r.id) !== -1);
  }

// True if *some* (but not all) visible rows are selected
  isSomeSelected(): boolean {
    return this.dataSource.data.some(r => this.selectedSamples.findIndex(s => s.id === r.id) !== -1) &&
        !this.isAllSelected();
  }

  selectSample(event: any, sample: LabSampleModel) {
    if (event.checked) {
      // Add to the array if checked
      if(this.selectedSamples.findIndex(s => s.id === sample.id) === -1) {
        this.selectedSamples.push(sample);
      }
    } else {
      // Remove from the array if unchecked
      const index = this.selectedSamples.findIndex(s => s.id === sample.id);
      if (index > -1) {
        this.selectedSamples.splice(index, 1);
      }
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes?.callResponse) {
      // Add depth column for soil type (pinTypeId 4 = soil pin type, labManTypesId 2 = soil)
      if (this.pinTypeId === 4 || this.pinTypeId === 2) {
        const sampleIdx = this.displayedColumns.indexOf("sample");
        if (sampleIdx !== -1 && !this.displayedColumns.includes("depth")) {
          this.displayedColumns.splice(sampleIdx + 1, 0, "depth");
        }
      } else {
        this.displayedColumns = this.displayedColumns.filter(c => c !== "depth");
      }
      this.totalElements = this.callResponse.totalElements;
      this.dataSource = new MatTableDataSource<any>(this.callResponse.content);
    }

    if(changes?.submissionStatus?.currentValue) {
      if(!this.isDialog) {
        this.displayedColumns = [
          'checkbox',
          'farm',
          'field',
          'hectare',
          'sample',
          'sampleReference',
          'sampleType',
          'dateCreated',
          'createdBy',
          'linkedGroup'
        ];
      }
      if(changes?.submissionStatus.currentValue >= 2) {
        this.displayedColumns.shift();
      } else {
        if(!this.isDialog) {
          this.displayedColumns.push('action')
        }
      }
    }
  }
}
